// // import React, { useEffect, useState } from "react";
// // import "./tenants.css";
// // import { Avatar } from "@mui/material";
// // import PhoneIcon from "../../assets/DashboardIcons/Phone.svg";
// // import APICall from "../../Utility/APICall";
// // import { paths } from "../../Utility/Constants";
// // import { useAuth } from "../../Utility/AuthProvider";
// // import CircularInitial from "../UpcomingRent/CircularInitial";

// // function Tenants() {
// //   const { jwt } = useAuth();
// //   const [data, setTenantData] = useState(null);

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         const response = await APICall(
// //           "GET",
// //           paths.tenant.fetchAll,
// //           undefined,
// //           undefined,
// //           jwt
// //         );
// //         console.log("Response:", response);
// //         setTenantData(response.response);
// //       } catch (error) {
// //         console.error("Error fetching data:", error);
// //       }
// //     };

// //     fetchData();
// //   }, [jwt]);

// //   return (
// //     <div className="tenants-container p-4">
// //       {/* Render data if available */}
// //       {data &&
// //         data.slice(0, 7).map((item, index) => (
// //           // className="hover:shadow-sm hover:bg-gray-100 rounded-md px-4"
// //           <div
// //             key={index}
// //             className="flex justify-between items-center pb-2 hover:shadow-xl rounded-md p-2"
// //           >
// //             <div className="flex items-center gap-2">
// //               <CircularInitial
// //                 firstName={item.first_name}
// //                 lastName={item.last_name}
// //               />
// //               <div>
// //                 <p>{item.name}</p>
// //                 <p>{item.mobile}</p>
// //               </div>
// //             </div>
// //             <div
// //               className="hover:bg-green-400"
// //               style={{
// //                 border: 1,
// //                 borderRadius: 99,
// //                 borderStyle: "solid",
// //                 padding: 10,
// //               }}
// //             >
// //               <img src={PhoneIcon} alt="Phone" height={15} width={15} />
// //             </div>
// //           </div>
// //         ))}
// //     </div>
// //   );
// // }

// // export default Tenants;

// import React, { useEffect, useState } from "react";
// // Removed tenants.css import
// import PhoneIcon from "../../assets/DashboardIcons/Phone.svg"; // Ensure path is correct
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import { useAuth } from "../../Utility/AuthProvider";
// import CircularInitial from "../UpcomingRent/CircularInitial"; // Ensure path is correct
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";

// function Tenants() {
//   const { jwt } = useAuth();
//   const [data, setTenantData] = useState([]); // Initialize with empty array
//   const [loading, setLoading] = useState(true); // Add loading state

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const response = await APICall(
//           "GET",
//           paths.tenant.fetchAll,
//           undefined,
//           undefined,
//           jwt
//         );
//         // Ensure response.response is an array before setting
//         setTenantData(
//           Array.isArray(response?.response) ? response.response : []
//         );
//         console.log("Tenants Response:", response);
//       } catch (error) {
//         console.error("Error fetching tenant data:", error);
//         setTenantData([]); // Set empty on error
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [jwt]);

//   return (
//     // Removed tenants-container class, parent Dashboard provides padding/bg/shadow
//     <div className="w-full">
//       {loading ? (
//         <div className="text-center text-gray-500 py-4">
//           {/* Loading... */}
//           <Lottie
//             animationData={loaderAnimation}
//             loop={true}
//             className="w-20 h-20 m-auto"
//           />
//         </div>
//       ) : data.length > 0 ? (
//         // Use space-y for vertical spacing between tenant items
//         <div className="space-y-3">
//           {/* Limit displayed tenants, e.g., first 5 */}
//           {data.slice(0, 5).map((item, index) => (
//             <div
//               key={item.entity_id || index} // Use a stable key like entity_id if available
//               // Add padding, border, hover effect
//               className="flex justify-between items-center p-3 border border-gray-200 rounded-md hover:shadow-sm transition-shadow"
//             >
//               {/* Left side: Avatar and Info */}
//               <div className="flex items-center gap-3">
//                 {" "}
//                 {/* Increased gap */}
//                 <CircularInitial
//                   firstName={item.first_name}
//                   lastName={item.last_name}
//                 />
//                 {/* Use consistent text sizes */}
//                 <div className="text-xs md:text-sm">
//                   <p className="font-medium text-gray-800">{item.name}</p>
//                   <p className="text-gray-500">{item.mobile}</p>
//                 </div>
//               </div>
//               {/* Right side: Phone Icon Button */}
//               {/* Use Tailwind for the button styling */}
//               <a
//                 href={`tel:${item.mobile}`} // Make it a clickable tel link
//                 className="flex items-center justify-center w-8 h-8 border border-gray-300 rounded-full hover:bg-green-100 hover:border-green-300 transition duration-150 ease-in-out"
//                 aria-label={`Call ${item.name}`}
//                 onClick={(e) => e.stopPropagation()} // Prevent potential parent clicks
//               >
//                 <img src={PhoneIcon} alt="Call" className="w-4 h-4" />{" "}
//                 {/* Adjusted size */}
//               </a>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="text-center text-gray-500 py-4">No tenants found.</div>
//       )}
//     </div>
//   );
// }

// export default Tenants;

import React from "react";
import PhoneIcon from "../../assets/DashboardIcons/Phone.svg";
import { useTenantContext } from "./TenantContext";
import CircularInitial from "../UpcomingRent/CircularInitial";

function Tenants() {
  // Get data from context instead of fetching
  const { tenantData, isLoadingTenants } = useTenantContext();

  // Don't show individual loader - let Dashboard handle loading state
  if (isLoadingTenants) {
    return null; // Return null instead of showing loader
  }

  return (
    <div className="w-full">
      {tenantData.length > 0 ? (
        <div className="space-y-3">
          {/* Limit displayed tenants to first 5 */}
          {tenantData.slice(0, 5).map((item, index) => (
            <div
              key={item.entity_id || index}
              className="flex justify-between items-center p-3 border border-gray-200 rounded-md hover:shadow-sm transition-shadow"
            >
              {/* Left side: Avatar and Info */}
              <div className="flex items-center gap-3">
                <CircularInitial
                  firstName={item.first_name}
                  lastName={item.last_name}
                />
                <div className="text-xs md:text-sm">
                  <p className="font-medium text-gray-800">{item.name}</p>
                  <p className="text-gray-500">{item.mobile}</p>
                </div>
              </div>
              {/* Right side: Phone Icon Button */}
              <a
                href={`tel:${item.mobile}`}
                className="flex items-center justify-center w-8 h-8 border border-gray-300 rounded-full hover:bg-green-100 hover:border-green-300 transition duration-150 ease-in-out"
                aria-label={`Call ${item.name}`}
                onClick={(e) => e.stopPropagation()}
              >
                <img src={PhoneIcon} alt="Call" className="w-4 h-4" />
              </a>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-500 py-4">No tenants found.</div>
      )}
    </div>
  );
}

export default Tenants;
